// extracted by mini-css-extract-plugin
export var container = "ShorexIcon-module--container--37fc6";
export var icon = "ShorexIcon-module--icon--e6b6e";
export var label = "ShorexIcon-module--label--c47e0";
export var sizeBig = "ShorexIcon-module--size-big--bb24e";
export var withDescription = "ShorexIcon-module--with-description--41577";
export var withLabel = "ShorexIcon-module--with-label--62444";
export var withShowLabelMobile = "ShorexIcon-module--with-show-label-mobile--ac42d";